export const normalizeFileMngrPath = (path, { trailingSlash = false } = {}) => {
    const normalized = String(path ?? '')
        .replace(/\\/g, '/')
        .replace(/\/+/g, '/')
        .replace(/^\/+|\/+$/g, '');

    if (normalized === '') {
        return '/';
    }

    return `/${normalized}${trailingSlash ? '/' : ''}`;
};

export const joinFileMngrPath = (...parts) =>
    normalizeFileMngrPath(parts.filter((part) => part !== null && part !== undefined && part !== '').join('/'), {
        trailingSlash: true
    });

export const appendFileMngrQuery = (url, parameters = {}) => {
    if (!url) {
        return null;
    }

    const search = new URLSearchParams(
        Object.entries(parameters).filter(([, value]) => value !== null && value !== undefined && value !== '')
    ).toString();

    if (search === '') {
        return url;
    }

    return `${url}${url.includes('?') ? '&' : '?'}${search}`;
};

export const fileMngrGetTempUrlParameters = (workWithTemp, tempFoldersName) =>
    workWithTemp
        ? new URLSearchParams({
              workingWithTemp: '1',
              tempFoldersName: tempFoldersName ?? '',
              targetIsTemp: '1'
          }).toString()
        : '';

export const getFileMngrItemParentPath = (item, currentPath) =>
    item?.filterPath ? joinFileMngrPath(currentPath, item.filterPath) : normalizeFileMngrPath(currentPath, { trailingSlash: true });

export const getFileMngrRenameBaseName = (item) => {
    const name = typeof item?.name === 'string' ? item.name : '';

    if (!item?.isFile) {
        return name;
    }

    const extensionIndex = name.lastIndexOf('.');

    return extensionIndex > 0 ? name.slice(0, extensionIndex) : name;
};

export const fileMngrItemId = (item, index) => `${item?.isFile === true ? 'file' : 'folder'}:${item?.name ?? ''}:${index}`;

export const getFileMngrErrorMessage = (response) => {
    const error = response?.data?.error ?? response?.error;

    if (typeof error === 'string') {
        return error;
    }

    return error?.message ?? response?.data?.message ?? response?.message ?? null;
};

export const isFileMngrResponseSuccessful = (response) =>
    response?.status === 200 && Number(response?.data?.code ?? 0) < 400 && !getFileMngrErrorMessage(response);

export const parseFileMngrDragData = (serializedData) => {
    if (!serializedData) {
        return null;
    }

    try {
        const data = JSON.parse(serializedData);
        return data && typeof data === 'object' ? data : null;
    } catch {
        return null;
    }
};
